export interface Port {
  id: string;
  icon: string;
  title: string;
  subtitle: string;
  desc: string;
  tag: string;
  href: string;
}

export const ports: Port[] = [
  {
    id: "adopt",
    icon: "ri-seedling-line",
    title: "农场认种",
    subtitle: "预订单众筹认种",
    desc: "连锁餐饮、企业集团、家族宗亲、兴趣社群，专属认种一块田",
    tag: "核心商业端口",
    href: "/adopt",
  },
  {
    id: "farm",
    icon: "ri-map-2-line",
    title: "农场种植",
    subtitle: "全国基地后台",
    desc: "多农场地图、地块看板、酵素农法标准化、区块链溯源",
    tag: "乡村基地端",
    href: "#gardens",
  },
  {
    id: "experience",
    icon: "ri-camera-3-line",
    title: "农场体验",
    subtitle: "农文旅社交",
    desc: "周末大巴、采摘露营、团建研学、自然疗愈、定制食谱",
    tag: "体验端口",
    href: "/experience",
  },
  {
    id: "feature",
    icon: "ri-landscape-line",
    title: "农文旅专题",
    subtitle: "三明农链工程",
    desc: "仙境景观、乡村振兴、社会帮扶、原生竹木石沙建造美学",
    tag: "专题频道",
    href: "/feature",
  },
  {
    id: "urban",
    icon: "ri-building-2-line",
    title: "城市田园改造",
    subtitle: "迷你植物森林",
    desc: "餐厅、别墅、酒店、屋顶、停车场，把自然搬进城市",
    tag: "城市消费端",
    href: "/urban",
  },
];

export interface ThemeGarden {
  id: string;
  name: string;
  category: string;
  desc: string;
  image?: string;
}

export const themeGardens: ThemeGarden[] = [
  {
    id: "baicao",
    name: "百草园康养主题园",
    category: "康养",
    desc: "药草奇花异果，酵素改良土地，滋养身心灵的天然药圃",
    image:
      "https://readdy.ai/api/search-image?query=Lush%20medicinal%20herb%20garden%20with%20rows%20of%20diverse%20green%20healing%20plants%2C%20wooden%20signposts%2C%20soft%20morning%20light%20and%20dewdrops%20on%20leaves%2C%20tranquil%20wellness%20atmosphere%2C%20stylized%20artistic%20botanical%20illustration%2C%20rich%20emerald%20green%20tones%2C%20serene%20natural%20composition&width=800&height=600&seq=home-garden-1&orientation=landscape",
  },
  {
    id: "baihua",
    name: "百花园美学主题园",
    category: "美学",
    desc: "四季繁花似锦，玫瑰牡丹野花，浪漫的美学栖居之地",
    image:
      "https://readdy.ai/api/search-image?query=Vibrant%20flower%20garden%20bursting%20with%20colorful%20seasonal%20blossoms%20of%20roses%20peonies%20and%20wildflowers%2C%20winding%20stone%20path%20and%20butterflies%2C%20soft%20golden%20afternoon%20light%2C%20romantic%20aesthetic%20atmosphere%2C%20artistic%20painterly%20illustration%2C%20cheerful%20warm%20color%20palette%2C%20harmonious%20composition&width=800&height=600&seq=home-garden-2&orientation=landscape",
  },
  {
    id: "baiguo",
    name: "百果园经济主题园",
    category: "经济",
    desc: "苹果桃李累累，丰收采摘经济，从枝头到餐桌的甜蜜",
    image:
      "https://readdy.ai/api/search-image?query=Abundant%20fruit%20orchard%20with%20ripe%20apples%20peaches%20and%20pears%20hanging%20from%20leafy%20trees%2C%20wooden%20fruit%20crates%20on%20the%20ground%2C%20warm%20autumn%20harvest%20light%2C%20joyful%20bountiful%20atmosphere%2C%20stylized%20artistic%20illustration%2C%20rich%20golden%20and%20red%20tones%2C%20inviting%20composition&width=800&height=600&seq=home-garden-3&orientation=landscape",
  },
  {
    id: "baishu",
    name: "百树园生态主题园",
    category: "生态",
    desc: "参天古木、林间溪流、苔藓奇石，一方静谧生态秘境",
    image:
      "https://readdy.ai/api/search-image?query=Tranquil%20forest%20garden%20of%20diverse%20tall%20trees%20with%20dappled%20sunlight%20filtering%20through%20canopy%2C%20mossy%20stones%20and%20a%20small%20stream%2C%20peaceful%20ecological%20atmosphere%2C%20misty%20morning%20light%2C%20artistic%20painterly%20landscape%2C%20deep%20emerald%20green%20tones%2C%20serene%20composition&width=800&height=600&seq=home-garden-4&orientation=landscape",
  },
  {
    id: "qinglv",
    name: "百年情侣情感主题园",
    category: "情感",
    desc: "花拱门、心形绿篱、喷泉长椅，以田园承载隽永情感",
    image:
      "https://readdy.ai/api/search-image?query=Romantic%20themed%20garden%20with%20a%20floral%20archway%2C%20heart%20shaped%20topiary%2C%20rose%20bushes%20and%20a%20small%20fountain%2C%20soft%20pink%20and%20green%20tones%2C%20dreamy%20twilight%20glow%2C%20a%20couple%20bench%2C%20artistic%20romantic%20illustration%2C%20gentle%20warm%20atmosphere%2C%20elegant%20composition&width=800&height=600&seq=home-garden-5&orientation=landscape",
  },
  {
    id: "zongqin",
    name: "家族宗亲传承主题园",
    category: "传承",
    desc: "亭台锦鲤、古树碑刻，让家族根脉在田园中生生不息",
    image:
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20family%20ancestral%20garden%20with%20a%20classic%20pavilion%2C%20koi%20pond%2C%20ancient%20trees%20and%20stone%20tablets%2C%20warm%20nostalgic%20light%2C%20cultural%20heritage%20atmosphere%2C%20stylized%20oriental%20ink%20painting%20illustration%2C%20earthy%20warm%20tones%2C%20dignified%20serene%20composition&width=800&height=600&seq=home-garden-6&orientation=landscape",
  },
  {
    id: "shangwu",
    name: "企业商务人脉主题园",
    category: "商务",
    desc: "竹构凉亭、长桌洽谈，把商会沙龙的商务链接带进田园",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20outdoor%20business%20garden%20meeting%20space%20with%20bamboo%20pergola%2C%20long%20wooden%20table%20and%20chairs%2C%20neatly%20trimmed%20hedges%2C%20modern%20rustic%20aesthetic%2C%20soft%20professional%20lighting%2C%20artistic%20stylized%20illustration%2C%20refined%20green%20and%20wood%20tones%2C%20sophisticated%20composition&width=800&height=600&seq=home-garden-7&orientation=landscape",
  },
  {
    id: "linli",
    name: "社区邻里共生主题园",
    category: "共生",
    desc: "共享菜畦、亲子游乐、树下长椅，重建温暖的邻里关系",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20community%20garden%20where%20families%20and%20neighbors%20gather%2C%20shared%20vegetable%20plots%2C%20children%20playing%2C%20picnic%20tables%20under%20trees%2C%20warm%20cheerful%20daylight%2C%20harmonious%20communal%20atmosphere%2C%20stylized%20artistic%20illustration%2C%20fresh%20green%20and%20warm%20tones%2C%20lively%20inviting%20composition&width=800&height=600&seq=home-garden-8&orientation=landscape",
  },
  {
    id: "meishijie",
    name: "美食街餐饮专属种植园",
    category: "餐饮",
    desc: "整条美食街集体认种，为餐厅定向供应溯源生态食材",
  },
  {
    id: "shipin",
    name: "食品工厂原料专属园",
    category: "原料",
    desc: "罐头工厂定向认种，定制酵素生态原料供应链",
  },
  {
    id: "qiyi",
    name: "棋艺静心主题园",
    category: "静心",
    desc: "石桌棋盘、竹林清风，在田园里对弈静心",
  },
  {
    id: "huihua",
    name: "绘画花艺美学园",
    category: "美学",
    desc: "写生花架、四季花材，滋养绘画与花艺创作灵感",
  },
  {
    id: "buyi",
    name: "布艺编织手作园",
    category: "手作",
    desc: "天然纤维、草木染坊，指尖流转的手作温度",
  },
  {
    id: "taoni",
    name: "陶泥艺术创作园",
    category: "创作",
    desc: "柴窑陶坊、泥坯拉胚，把泥土塑造成艺术",
  },
  {
    id: "yujia",
    name: "瑜伽健身疗愈园",
    category: "疗愈",
    desc: "晨雾草坪、森林冥想，在自然中疗愈身心",
  },
  {
    id: "dushu",
    name: "读书沙龙智慧园",
    category: "智慧",
    desc: "竹林书斋、星空夜读，以书香滋养智慧圈层",
  },
];

export interface ValueItem {
  id: string;
  icon: string;
  title: string;
  desc: string;
  points: string[];
}

export const values: ValueItem[] = [
  {
    id: "industry",
    icon: "ri-treasure-map-line",
    title: "产业价值",
    desc: "落地预订单酵素农业，为餐饮食品企业提供溯源生态食材",
    points: ["降低产销风险", "认种创造稳定收入", "景观工程新赛道"],
  },
  {
    id: "ecology",
    icon: "ri-leaf-line",
    title: "生态价值",
    desc: "酵素改良板结土壤修复土地，城市迷你植物森林打造天然氧吧",
    points: ["酵素改良土壤", "城市天然氧吧", "滋养身心灵"],
  },
  {
    id: "social",
    icon: "ri-heart-3-line",
    title: "社会价值",
    desc: "帮扶共建群体，重建邻里、家族、企业与兴趣圈层的关系",
    points: ["大学生创业平台", "帮扶共建群体", "重建社会关系"],
  },
  {
    id: "culture",
    icon: "ri-ancient-gate-line",
    title: "人文价值",
    desc: "打造九宫八卦东方田园仙境，传承华夏农耕文化",
    points: ["九宫八卦布局", "传承农耕文化", "田园承载梦想"],
  },
];

export interface Slide {
  id: string;
  tag: string;
  title: string;
  subtitle: string;
  desc: string;
  points: string[];
  image: string;
}

export const urbanRuralSlides: Slide[] = [
  {
    id: "rural",
    tag: "乡村城市化",
    title: "仙境农场 · 全国网格布局",
    subtitle: "九宫八卦田园仙境",
    desc: "全国多点农场规模化、标准化、网格化布局，分散规避天灾风险，打造易经九宫八卦布局的东方田园仙境。",
    points: ["全国多点农场", "酵素农法标准", "分散风险布局"],
    image:
      "https://readdy.ai/api/search-image?query=Aerial%20stylized%20view%20of%20a%20grand%20oriental%20farm%20estate%20arranged%20in%20nine%20palace%20grid%20pattern%2C%20vibrant%20green%20crop%20fields%2C%20winding%20rivers%20and%20stone%20bridges%2C%20bamboo%20groves%2C%20wooden%20pavilions%20and%20tiny%20farmhouses%2C%20warm%20sunset%20glow%2C%20artistic%20painterly%20landscape%20illustration%2C%20lush%20emerald%20and%20golden%20tones&width=1200&height=800&seq=home-rural-1&orientation=landscape",
  },
  {
    id: "urban",
    tag: "城市乡村化",
    title: "迷你植物森林 · 城市天然氧吧",
    subtitle: "把自然搬进城市空间",
    desc: "把迷你植物森林移植到餐厅、别墅、酒店、屋顶、地下停车场、卧室等各类城市场景，打造城市天然氧吧。",
    points: ["全场景改造", "绿植托管养护", "城市食材配送"],
    image:
      "https://readdy.ai/api/search-image?query=Modern%20restaurant%20interior%20transformed%20into%20a%20lush%20miniature%20botanical%20forest%2C%20living%20green%20plants%20on%20wooden%20shelves%20and%20hanging%20vines%2C%20small%20potted%20trees%20on%20tables%2C%20warm%20cozy%20ambient%20lighting%2C%20elegant%20urban%20oasis%20atmosphere%2C%20stylized%20artistic%20rendering%2C%20emerald%20green%20and%20warm%20wood%20tones%2C%20serene%20and%20inviting&width=1200&height=800&seq=home-urban-1&orientation=landscape",
  },
];

export interface Stat {
  value: string;
  label: string;
}

export const stats: Stat[] = [
  { value: "16", label: "主题园体系" },
  { value: "5", label: "业务端口" },
  { value: "16", label: "用户角色" },
  { value: "4", label: "业务闭环" },
];